export const YANDEX_STORIES_SCROLL_STEP = 200;
